import React, { useState } from 'react';
import { CreateChancel } from 'components';
import { Images, useModal } from 'utils';
import { Radio } from '@mui/material';
import { CreateSection } from './createSection';
import { AddFromLibrary } from './addFromLibrary';
import { AddCustomSection } from './addCustomSection';

const typeEnums = {
    NEW: 'NEW',
    EXISTING: 'EXISTING',
    CUSTOM: 'CUSTOM',
};

export const AddSection = ({ onCreateSection, formList, setFormList, fromReport, clientId }) => {
    const [selected, setSelected] = useState(null);
    const [error, setError] = useState(null);
    const { open, close } = useModal();
    const model = formList?.model;

    const newSectionTypes = [
        {
            title: 'Create New Section',
            subtitle: 'Start a new section and add fields manually',
            background: '#E7F0FC',
            boxShadow: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
            icon: Images.plus,
            enum: typeEnums.NEW,
        },
        {
            title: 'Add from Existing',
            subtitle: 'Reuse saved sections',
            background: '#F9F5FF',
            boxShadow: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
            icon: Images.sectionFolder,
            enum: typeEnums.EXISTING,
            disabled: !model,
        },
        fromReport && {
            title: 'Add Custom Section',
            subtitle: 'Use saved custom sections with pre-filled data fields',
            background: '#F4EBFF',
            boxShadow: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
            icon: Images.customSections,
            enum: typeEnums.CUSTOM,
            disabled: !model,
        },
    ];

    const handleContinue = () => {
        if (!selected) {
            setError('type');
            return;
        }

        if (selected === typeEnums.NEW) {
            close();
            open(<CreateSection formList={formList} onCreateSection={onCreateSection} />, {
                styles: {
                    bodyStyle: { padding: 0 },
                },
            });
        }
        if (selected === typeEnums.EXISTING) {
            open(<AddFromLibrary formList={formList} setFormList={setFormList} />, {
                styles: {
                    bodyStyle: { padding: 0 },
                },
            });
        }
        if (selected === typeEnums.CUSTOM) {
            close();
            open(<AddCustomSection clientId={clientId} formList={formList} setFormList={setFormList} />, {
                styles: {
                    bodyStyle: { padding: 0 },
                },
            });
        }
    };

    return (
        <div style={{ width: 560 }}>
            <div className="modal-section-padding" style={{ borderBottom: '1px solid #DFE1E6' }}>
                <p className="modal-header-title">Add Section</p>
                <p className="modal-box-title" style={{ color: '#475467', fontWeight: 400 }}>
                    Choose how you want to add a section to this template.
                </p>
            </div>

            <div className="modal-section-padding column" style={{ gap: 12 }}>
                {newSectionTypes?.map(
                    (item, index) =>
                        item && (
                            <div
                                style={
                                    selected === item?.enum
                                        ? {
                                              border: '1px solid #B4D0F6',
                                              background: '#F5F9FE',
                                          }
                                        : error === 'type'
                                        ? {
                                              border: '1px solid #FE7070',
                                          }
                                        : {}
                                }
                                className={`section-choose-item-box ${item?.disabled && 'disabled-section'}`}
                                key={index}>
                                <div className="section-choose-item-info-box">
                                    <div
                                        style={{ background: item?.background, boxShadow: item?.boxShadow }}
                                        className="section-choose-item-image">
                                        <img src={item?.icon} alt="icon" />
                                    </div>
                                    <div className="section-choose-item-text">
                                        <p>{item?.title}</p>
                                        <span>{item?.subtitle}</span>
                                    </div>
                                </div>

                                <Radio
                                    disabled={item?.disabled}
                                    value={item?.enum}
                                    checked={selected === item?.enum}
                                    style={{
                                        background: 'transparent',
                                        color: selected === item?.enum ? '#347AF0' : '#D0D5DD',
                                        padding: 0,
                                    }}
                                    onChange={(e) => {
                                        setSelected(e.target.value);
                                        setError(null);
                                    }}
                                />
                            </div>
                        )
                )}
            </div>

            <div className="modal-section-padding">
                <CreateChancel
                    // loader={!!loader.length}
                    create={'Continue'}
                    chancel={'Cancel'}
                    onCreate={handleContinue}
                    onClose={() => close()}
                    buttonWidth="100%"
                    cancelButtonWidth="100%"
                />
            </div>
        </div>
    );
};
